import {groq} from 'next-sanity';

import {DOCUMENT_TYPE_ABOUT_FRONTPAGE} from '@/modules/finkn/about/frontpage/sanity/constants';
import {PAGE_FRAGMENT} from '@/modules/page/sanity/page/query';

import {DOCUMENT_TYPE_NEMND_FRONTPAGE} from './constants';

export const nemndFrontpageQuery = groq`
	*[_type == "${DOCUMENT_TYPE_NEMND_FRONTPAGE}"][0]{
		${PAGE_FRAGMENT},
		"parent": *[_type == "${DOCUMENT_TYPE_ABOUT_FRONTPAGE}"][0] {
			title,
			_type
		}
	}
`;
